import { SVG } from '../SVG'

const PaperPlaneIcon = ({ style = {}, ...props }) => (
  <SVG
    width='75'
    height='75'
    viewBox='0 0 75 75'
    fill='none'
    strokeWidth='3'
    strokeLinecap='round'
    strokeLinejoin='round'
    xmlns='http://www.w3.org/2000/svg'
    style={{ stroke: 'var(--primary-color)', ...style }}
    {...props}
  >
    <path d='M25.7819 39.5215L52.1198 62.6953C52.4241 62.9648 52.7934 63.1505 53.1912 63.2341C53.589 63.3177 54.0018 63.2964 54.3889 63.1723C54.776 63.0482 55.1242 62.8255 55.3992 62.5262C55.6742 62.2268 55.8667 61.8611 55.9576 61.4649L66.9733 13.3594C67.0656 12.9451 67.0438 12.5135 66.91 12.1107C66.7762 11.7079 66.5356 11.3489 66.2137 11.0722C65.8919 10.7955 65.5009 10.6113 65.0826 10.5395C64.6643 10.4676 64.2343 10.5107 63.8385 10.6641L9.75647 31.9043C7.5885 32.7539 7.88147 35.918 10.1666 36.3867L25.7819 39.5215Z' />
    <path d='M25.7812 39.5215L65.6543 10.7227' />
    <path d='M38.9355 51.0937L29.7949 60.2344C29.4688 60.5655 29.0516 60.7922 28.5964 60.8857C28.1411 60.9792 27.6684 60.9352 27.2382 60.7593C26.808 60.5835 26.4398 60.2837 26.1804 59.8981C25.921 59.5125 25.782 59.0585 25.7812 58.5937V39.5215' />
  </SVG>
)

export default PaperPlaneIcon
